import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "system_overview_press",
  "use": "system_overview_press-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"system_overview_press\"><path d=\"M3.07 12H7.5v1h-2c-.28 0-.5.22-.5.5s.22.5.5.5h5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5h-2v-1h4.43c1.12 0 2.03-.89 2.07-2H1.01c.04 1.11.94 2 2.06 2m9.86-10H3.07C1.93 2 1 2.93 1 4.07V9h14V4.07C15 2.93 14.07 2 12.93 2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol